module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plthumb grid"
  }, [(_vm.lazy) ? _c('router-link', {
    attrs: {
      "to": "/browse/building/" + _vm.building.slug
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('https://img.therenees.com/' + _vm.building.photo),
      expression: "'https://img.therenees.com/'+building.photo"
    }]
  })]) : _vm._e(), _vm._v(" "), (!_vm.lazy) ? _c('router-link', {
    attrs: {
      "to": "/browse/building/" + _vm.building.slug
    }
  }, [_c('img', {
    attrs: {
      "src": 'https://img.therenees.com/' + _vm.building.photo
    }
  })]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.building.name))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-609758a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BuildingThumb.vue
// module id = 208
// module chunks = 1